export default function detectFeatureHits(map, options = {}) {
    let previousFeature = null;
    const { layers, onEnter, onLeave } = options;
    const layerFilter = layers && layers.length
        ? (layer) => layers.indexOf(layer) > -1
        : undefined;
    function onFeatureHit(feature, layer) {
        if (!layer || feature === previousFeature) {
            return;
        }
        if (previousFeature) {
            onLeave?.(previousFeature);
        }
        previousFeature = feature;
        onEnter?.(feature);
    }
    function onPointerMove(e) {
        if (e.dragging) {
            return;
        }
        const pixel = map.getEventPixel(e.originalEvent);
        let foundFeature = false;
        map.forEachFeatureAtPixel(pixel, (feature, layer) => {
            foundFeature = true;
            onFeatureHit(feature, layer);
        }, { layerFilter: layerFilter });
        if (!foundFeature && previousFeature) {
            onLeave?.(previousFeature);
            previousFeature = null;
        }
    }
    map.on("pointermove", onPointerMove);
}
